// extracted by mini-css-extract-plugin
module.exports = {"Content":"RoundHistory_Content__3TafA","CopyButton":"RoundHistory_CopyButton__26vBS"};